export const createDefaultObj = branch => {
  return {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    realm: branch,
    branch
  }
}

//Making this function because complier can't infer nullish coalescing operator
export const nullCoalesce = (value, fallback = '') => {
  return value === null || value === undefined ? fallback : value
}
